import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Catch-all loggers so any uncaught error (sync OR async promise
// rejection) lands in the console with a stable "[GLOBAL]" prefix the
// user can grep for among all the image-404 noise. The browser
// already prints these — these handlers just add a clearer banner so
// the line is findable in a flood.
window.addEventListener("error", (event) => {
  console.error(
    "[GLOBAL] Uncaught error:",
    event.message,
    "at",
    event.filename,
    `${event.lineno}:${event.colno}`,
    event.error,
  );
});
window.addEventListener("unhandledrejection", (event) => {
  console.error("[GLOBAL] Unhandled promise rejection:", event.reason);
});

const mountNode = document.getElementById("gammill-configurator");
if (mountNode) {
  ReactDOM.createRoot(mountNode).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
